import * as React from "react"
import Button from "../../common/blocks/button/Button"
import CtxHeroSection from "../../common/sections/ctx-hero-section/CtxHeroSection"

const RhHeaderHeroButtonsSection = ({ title, text, image, buttons }) => {
  return (
    <CtxHeroSection image={image} imgSrc={image.url} imgAlt={image.alt}>
        <h1 className={"ternary-text-color pre-wrap"}>
          <strong>{title}</strong>
        </h1>
        {text && <p className={"ternary-text-color pre-wrap mt-2"}>{text}</p>}
        {buttons.length > 0 && (
          <div className="buttons mt-4">
            {buttons.map((b, i) => (
              <Button
                aspect={b.style}
                color={b.color}
                size={b.size}
                key={i}
              >
                {b.text}
              </Button>
            ))}
          </div>
        )}
    </CtxHeroSection>
  )
}

export const name = "RhHeaderHeroButtonsSection"

export const init = (componentData, pageContext) => {
  return (
    <RhHeaderHeroButtonsSection
      key={componentData.id}
      title={componentData.title}
      text={componentData.text}
      image={componentData.image?.data?.attributes}
      buttons={componentData.buttons}
    />
  )
}

export default RhHeaderHeroButtonsSection
